import { createContext } from 'react';
import { AccessibilityContextType } from '../types/accessibility.types';

export const AccessibilityContext =
  createContext<AccessibilityContextType | null>(null);